import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BigNews = () => {
  const BIG_NEWS_ALERT_KEY = 'big-news-alert'
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(window.sessionStorage.getItem(BIG_NEWS_ALERT_KEY) !== 'true')
  }, [])

  const onClose = () => {
    setVisible(false)

    window.sessionStorage.setItem(BIG_NEWS_ALERT_KEY, 'true')
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 inset-x-0 pb-2 sm:pb-5">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div className="p-2 rounded-lg bg-gradient-to-r from-indigo-600 to-blue-500 shadow-lg sm:p-3">
          <div className="flex items-center justify-between flex-wrap">
            <div className="w-0 flex-1 flex items-center">
              <span className="flex p-2 rounded-lg bg-blue-700">
                <FontAwesomeIcon
                  icon="bullhorn"
                  className="text-white fa-flip-horizontal"
                />
              </span>

              <p className="m-0 mr-3 font-medium text-white truncate">
                <span className="md:hidden">
                 إطلاق مشروع العملات اليمنية
                </span>
                <span className="hidden md:inline">
                 إطلاق مشروع العملات اليمنية
                </span>
              </p>
            </div>

            <div className="order-3 mt-2 ml-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
              <a
                href="https://yemen-currency.iwatheq.com"
                target="_blank"
                rel="noreferrer noopener"
                className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50"
              >
                اعرف المزيد &larr;
              </a>
            </div>

            <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
              <button
                type="button"
                className="-ml-1 flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white"
                onClick={onClose}
              >
                <span className="sr-only">Dismiss</span>
                <FontAwesomeIcon icon="times" className="text-white text-lg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BigNews
